import { render, staticRenderFns } from "./confirmation-question.vue?vue&type=template&id=16b85627&scoped=true"
import script from "./confirmation-question.vue?vue&type=script&lang=js"
export * from "./confirmation-question.vue?vue&type=script&lang=js"
import style0 from "./confirmation-question.vue?vue&type=style&index=0&id=16b85627&prod&scoped=true&lang=scss&module=true"




function injectStyles (context) {
  
  this["$style"] = (style0.locals || style0)

}

/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  injectStyles,
  "16b85627",
  null
  
)

export default component.exports